<template>
  <div
    class="flex items-center justify-center fixed top-0 left-0 w-full min-w-full h-full min-h-full z-50"
  >
    <div>
      <div class="flex justify-center mb-8">
        <img
          v-if="isIXRoute"
          src="https://www.ix.golf/hs-fs/hubfs/IX-Logo-3-3.png?width=500&height=500&name=IX-Logo-3-3.png"
          alt="IX Logo"
          class="h-16 w-16 object-contain animate-pulse"
        />
        <div v-else>
          <div class="flex">
            <div class="w-5 h-5" />
            <div class="w-5 h-5 bg-pmg-400" />
            <div class="w-5 h-5" />
          </div>
          <div class="flex">
            <div class="w-5 h-5 bg-pmg-400" />
            <div class="w-5 h-5 bg-pmg-800" />
            <div class="w-5 h-5 bg-pmg-100" />
          </div>
          <div class="flex">
            <div class="w-5 h-5" />
            <div class="w-5 h-5 bg-pmg-100" />
            <div class="w-5 h-5" />
          </div>
        </div>
      </div>

      <div>
        <div class="w-56 bg-gray-200 overflow-hidden full h-2 border border-gray-300">
          <div
            class="h-full bg-gray-400 transition-all"
            :style="
              'width:' + loadingWidth + '%; transition-duration:' + transitionDuration + 'ms;'
            "
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      loading: {
        type: Boolean,
        default: true,
      },
    },

    data() {
      return {
        loadingWidth: 1,
      };
    },

    computed: {
      isIXRoute() {
        if (!this.$route) return false;
        const path = this.$route.path || '';
        const hash = window.location.hash || '';
        return path.includes('/IX') || hash.includes('/IX');
      },
      transitionDuration() {
        if (this.loading) {
          return 75;
        }
        return 35;
      },
    },

    watch: {
      loading() {
        this.close();
      },
    },

    mounted() {
      this.initLoading();
    },

    methods: {
      initLoading() {
        this.loadingWidth++;

        if (this.loadingWidth < 100) {
          const duration = this.loading ? 75 : 35;
          setTimeout(() => this.initLoading(), duration);
        } else {
          this.close();
        }
      },

      close() {
        if (this.loadingWidth >= 100 && !this.loading) {
          setTimeout(() => this.$emit('close'), 75);
        }
      },
    },
  };
</script>
